import { Component } from 'react';
import './style.css';
import { MdOutlineMergeType } from 'react-icons/md';
import {
  PaneDirective,
  PanesDirective,
  SplitterComponent,
} from '@syncfusion/ej2-react-layouts';
import { Link, Outlet } from 'react-router-dom';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import dataSource from './hier-data.json';
import {
  EditSettingsModel,
  FilterSettingsModel,
  PageSettingsModel,
} from '@syncfusion/ej2-react-grids';
import { all_information } from '../../App';
interface IState {
  resizeOpacity: any;
}
interface IProps {
  navigation?: any;
}
export default class MainTab extends Component<IProps, IState> {
  data = dataSource;
  public validationRule: Object = { required: true };
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      resizeOpacity: 1,
    };
  }

  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  contentMain = () => {
    return (
      <div>
        <Outlet />
      </div>
    );
  };
  private nodeTemplate(data: any): JSX.Element {
    var element: JSX.Element = <div></div>;
    let theInfo=all_information;
    if (data.endPoint) {
      element = (
        <div>
          <Link
            style={{ textDecoration: 'none',}}
            to={data.path}
            className='eachParSubTitle'
          >
            <MdOutlineMergeType />
            <div className='eachSubTitle'>{data.name}</div>
          </Link>
        </div>
      );
    } else {
      element = (
        <span
          style={{
            fontSize: data.hasChild ? '16px' : '14px',
            fontWeight: data.hasChild ? '800' : 'normal',
            color: data.hasChild ? 'rgb(34, 211, 238)' : '',
            cursor: 'pointer',
            display: 'inline-block',
            textOverflow: 'ellipsis',
            verticalAlign: 'midlle',
            whiteSpace: 'nowrap',
            width: '100%',
            fontFamily: `"Roboto", "Segoe UI", "GeezaPro", "DejaVu Serif", "sans-serif"`,
          }}
        >
          {data.name}
        </span>
      );
    }
    return <div>{element}</div>;
  }
  contentSide = () => {
    return (
      <TreeViewComponent
        enablePersistence={true}
        fields={{
          id: 'id',
          parentID: 'pid',
          text: 'name',
          hasChildren: 'hasChild',
          dataSource: dataSource.templateData as any,
        }}
        nodeTemplate={this.nodeTemplate as any}
      />
    );
  };
  componentDidMount() {
    // this.props.navigation("/settings/eventStatus/")
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    // this.props.navigation("/settings/eventStatus/")
  }
  render() {
    return (
      <>
        <SplitterComponent
          id='expand-collapse'
          className='splitter'
          height='94.3vh'
        >
          <PanesDirective>
            <PaneDirective
              size='20%'
              content={this.contentSide.bind(this)}
              resizable={true}
              collapsible={true}
            />
            <PaneDirective
              size='80%'
              content={this.contentMain.bind(this)}
              collapsible={false}
              collapsed={false}
            />
          </PanesDirective>
        </SplitterComponent>
      </>
    );
  }
}
// export default function (props: any) {
//   const navigation = redirect;
//   return <MainTab navigation={navigation} />;
// }
